import { useEffect } from "react";
import { setSentryUser, clearSentryUser } from "@utils/sentry";
import { useGetIdentity, usePermissions } from "@refinedev/core";
import { IAuthRoles, IAuthUser } from "@auth/firebase/interfaces";

export const SentryUserTracker: React.FC = () => {
  const { data: roleData } = usePermissions<IAuthRoles>()
  const { data: identity } = useGetIdentity<IAuthUser>();
  const role = roleData?.role

  // Track user information in Sentry when role changes
  useEffect(() => {
    // console.log(role, identity)
    if (identity?.user_id) {
      setSentryUser({
        id: identity.user_id,
        uid: identity.user_uid,
        email: identity.email || undefined,
        username: identity.displayName || undefined,
        role: role,
      });
    } else {
      clearSentryUser();
    }
  }, [role, identity?.user_id]);

  return null; // This component doesn't render anything
}; 